(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("7WMih", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5a177098819e795d$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $exvWl = parcelRequire("exvWl");
const $5a177098819e795d$var$FormHidden = ({ name: name, value: value, required: required })=>{
    const { formState: formState, register: register } = (0, $exvWl.useFormContext)();
    let error = formState.errors?.[name];
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)("input", {
                autoComplete: "off",
                type: "hidden",
                ...register(name, {
                    required: required
                }),
                onChange: (e)=>{
                    error = undefined;
                },
                value: value
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("p", {
                className: "text-red500 text-tiny absolute my-0",
                children: error?.type === "required" && `F\xe4ltet \xe4r obligatoriskt`
            })
        ]
    });
};
var $5a177098819e795d$export$2e2bcd8739ae039 = $5a177098819e795d$var$FormHidden;

});

})();
//# sourceMappingURL=FormHidden.c0787140.js.map
